<template>
    <div class="current-audio my-3">
        <div class="pb-3 border-bottom" v-for="file in files" v-bind:key="file.id">
            <div class="mb-3">
                <audio :src="file.url" controls>Message</audio>
            </div>
            <strong>
                {{ file.file_name }}
            </strong>
            <span class="badge badge-danger clickable remove float-right" @click="removeItem(file.id)">remove</span>
        </div>
    </div>
</template>

<script>

    import eventHub from '../components/EventHub';

    export default {

        mounted() {
            this.refresh();
        },

        created(){
            eventHub.$on('audioAdded', (e) => {
                this.refresh();
            });
        },

        props:['model_id','model_type','collection'],

        data() {
            return {
                files: [],
                errors: [],
            }
        },

        computed: {

        },

        methods: {

            removeItem(id){
                console.log(id);
                this.errors = [];
                axios.post('/admin/deleteSpatieMedia', { 
                    id: id,
                 })
                .then(response => {
                    this.message = response.data.message;
                    this.refresh();
                })
                .catch(errors => {
                    this.errors = response.data.errors;
                });
            },

            refresh(){
                let url = '/admin/getMedia/' + this.model_type + '/' + this.model_id + '/' + this.collection;
                axios.get(url)
                .then(response => {
                    // console.log(response);
                    this.files = response.data.pictures;
                })
                .catch(errors => {
                    this.errors = response.data.errors;
                });
            },

        },

    }
</script>

<style scoped>
 audio {
     width: 100%;
 }
</style>